import React, { FunctionComponent, ReactNode } from 'react';
import { Heading, Image } from '@ds/ui';
import { inkFontTokens, inkSpacingTokens } from '@ds/tokens';
import styled from '@emotion/styled';
import { ConditionalChildren } from 'layouts';
import { TranslationContext } from '@ds/react-utils';

const ContainerLayoutHeaderTitleContainer = styled.div`
    p {
        margin-top: ${inkSpacingTokens.spacingXS};
        ${inkFontTokens.fontBodyL}
    }
`;

const ImageContainer = styled.div`
    margin: ${inkSpacingTokens.spacingXS} 0;
`;

interface ContainerLayoutHeaderTitleProps {
    title: string;
    subTitle?: ReactNode;
    titleDataQa?: string;
    subTitleDataQa?: string;
    icon?: string;
}

const ContainerLayoutHeaderTitle: FunctionComponent<ContainerLayoutHeaderTitleProps> = ({ title, subTitle, titleDataQa, subTitleDataQa, icon }) => {
    const translate = React.useContext(TranslationContext);

    return (
        <ContainerLayoutHeaderTitleContainer>
            <ConditionalChildren condition={Boolean(icon)}>
                <ImageContainer>
                    <Image src={icon || ''} alt={translate('Header title icon')} data-qa="header-title-icon" />
                </ImageContainer>
            </ConditionalChildren>

            <div tabIndex={-1}>
                <Heading level="1" text={title} data-qa={titleDataQa || 'header-title-ink'} />
            </div>

            <ConditionalChildren condition={undefined !== subTitle}>
                <p data-qa={subTitleDataQa}>{subTitle}</p>
            </ConditionalChildren>
        </ContainerLayoutHeaderTitleContainer>
    );
};

export default ContainerLayoutHeaderTitle;
